import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { Transition } from 'lumen/services/transition';

export default class HotelSettingsCompetitorsRoute extends Route {
  @service declare access: Services['access'];
  @service declare navigation: Services['navigation'];
  @service declare router: Services['router'];

  beforeModel(transition: Transition): void {
    if (this.navigation.redirectToAccountSelection(transition)) {
      return;
    }

    if (!this.access.hasAccessCompsets) {
      this.router.transitionTo('hotel.settings.index');
    }

    if (
      this.access.hasAppCompset &&
      this.access.isPricingAssistantStandaloneVersion && // PriMa standalone version does not have RMS compset
      !this.access.hasCompsetBenchmark &&
      !this.access.hasCompsetBenchmarkSmartCompset &&
      !this.access.hasSettingsBenchmarkPortfolioCompsetView
    ) {
      this.router.transitionTo('hotel.settings.competitors.general');
    }
  }
}
